import Swiper, { Thumbs, Navigation, Pagination, Zoom, EffectFade } from "swiper/core"

Swiper.use([Thumbs, Navigation, Pagination, Zoom, EffectFade])

const blogTagNav = {
  initGallery() {
    if(document.querySelector('.blogCategories .swiper-container')) {
      if (window.innerWidth <= 1024) {
        let activeSlide = document.querySelector('.blogCategories .swiper-container .tag-nav.active').dataset.index;

        return new Swiper('.blogCategories .swiper-container', {
          slidesPerView: "auto",
          initialSlide: activeSlide
        })
      }
    }
  },

  init() {
    this.initGallery()
  }
}

export default blogTagNav